import React, { PureComponent, createRef } from 'react'
import qrCode from 'qrcode'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  Button,
  withStyles,
} from '@material-ui/core'
import {
  Send as SendIcon,
  Print as PrintIcon,
} from '@material-ui/icons'


import { printCanvas } from '../helpers'
import Inline from './Inline'


const styles = theme => ({
  root: {
    height: 250,
    paddingLeft: 0,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
    justifyContent: 'space-between',
  },
  canvas: {
    width: 150,
    height: 150,
  },
  button: {
    justifyContent: 'center',
  },
})


class Qrcode extends PureComponent {
  /* LIFECYCLE */

  /**
   * @constructor
   * @param {*} props - Properties of the PureComponent
   */
  constructor(props) {
    super(props)

    this.canvas = createRef()
  }

  /**
   * @componentDidMount
   */
  componentDidMount() {
    const { value } = this.props

    if (value) {
      this.generateQrcode(value)
    }
  }

  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the PureComponent
   */
  componentWillReceiveProps(nextProps) {
    const { value } = nextProps

    if (value && value !== this.props.value) {
      this.generateQrcode(value)
    }
  }


  /* METHODS */

  generateQrcode = (value) => {
    const { current: canvas } = this.canvas

    if (value && canvas) {
      qrCode.toCanvas(canvas, value)
    }
  }

  handlePrint = () => {
    const { current: canvas } = this.canvas

    printCanvas(canvas)
  }

  handleMailto = () => {
    const { current: canvas } = this.canvas

    if (canvas) {
      this.props.onEmailQRCode(canvas.toDataURL())
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      classes,
      className,
      isLoading,
      canvasClassName,
    } = this.props

    return (
      <div className={classNames(classes.root, className)}>
        <canvas
          ref={this.canvas}
          className={classNames(classes.canvas, canvasClassName)}
        />
        <Inline>
          <Button
            fullWidth
            variant="outlined"
            disabled={isLoading}
            className={classes.button}
            onClick={this.handlePrint}
          >
            <PrintIcon />
          </Button>
          <Button
            fullWidth
            component="a"
            target="_blank"
            variant="outlined"
            disabled={isLoading}
            className={classes.button}
            onClick={this.handleMailto}
          >
            <SendIcon />
          </Button>
        </Inline>
      </div>
    )
  }
}


Qrcode.propTypes = {
  value: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  onEmailQRCode: PropTypes.func,
  canvasClassName: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Qrcode)
